import React, { useState, useEffect, forwardRef, Fragment } from "react";
import {FormControl,
        InputLabel,
        Input,
        Grid,
        InputAdornment,
        Chip,
        Select,
        MenuItem,
        TextField,
        FormHelperText
} from "@material-ui/core";
import CategoryIcon from '@material-ui/icons/Category';
import classnames from "classnames";
import useStyles from './styles';
import { useUserState } from "../../context/UserContext";

import './SelectSiteTestingScopes.css'


const SelectSiteTestingScopes = forwardRef((props, ref) => {
    const { onTestingScopesSelected, onOtherTestingScopesSpecified } = props
    var { testing_scopes } = useUserState();
    const classes = useStyles();

    const [site, setSite] = useState({...props.site});
    const [selectedTestingScopes, setSelectedTestingScopes] = useState(undefined);
    const [notes, setNotes] = useState(undefined);
    const [testingScopesSelectionOpen, setTestingScopesSelectionOpen] = React.useState(false);


    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };


    useEffect(() => {console.log('>>><<<',testing_scopes)
      if (site !== undefined && site !== null) {
        // for edit site
        if (site.id !== undefined && site.id > 0) {
          if (site.testing_scopes !== undefined && site.testing_scopes !== null && site.testing_scopes.length > 0) {
            setSelectedTestingScopes(site.testing_scopes);
          }

          if (site.testing_scope_other_notes !== undefined && site.testing_scope_other_notes !== null && site.testing_scope_other_notes !== '') {
            setNotes(site.testing_scope_other_notes);
          }
        }
        else {
          if (site.testing_scopes === undefined || site.testing_scopes === null || site.testing_scopes.length <= 0) {
             // you can save without selecting testing scopes
          }
          else {
            if (props.isAddSite) {
              refreshTestingScopesSelection();
            }
            else {
              setSelectedTestingScopes(site.testing_scopes);
            }
          }
        }
      }
    }, [site]);

    useEffect(() => {
      onTestingScopesSelected(selectedTestingScopes);
    },[selectedTestingScopes]);

    function refreshTestingScopesSelection() {
      var newSiteTestingScopes = site.testing_scopes;
      newSiteTestingScopes = newSiteTestingScopes.filter(testingScope => testing_scopes.filter(item => item.id === testingScope.id).length === 1);
      setSelectedTestingScopes(newSiteTestingScopes);
      if (site.testing_scope_other_notes !== undefined && site.testing_scope_other_notes !== null && site.testing_scope_other_notes !== '') {
          setNotes(site.testing_scope_other_notes);
      }

      onTestingScopesSelected(newSiteTestingScopes);
    }

    const handleChange = (event) => {
        setSelectedTestingScopes(event.target.value);
    };

    const handleDelete = (id) => {
      const updatedTestingScopes = selectedTestingScopes.filter(item => item.id !== parseInt(id));
      setSelectedTestingScopes(updatedTestingScopes);
    };

    const onMouseDown = e => {
      e.stopPropagation();
    };

    const handleOtherTestingScopesSpecified=(event) => {
        setNotes(event.target.value);
        onOtherTestingScopesSpecified(event.target.value);
    }

  return ( testing_scopes && testing_scopes.length > 0 &&
    <div className={classes.contentDiv}>


        <Grid container spacing={4}>
        <Grid item xs={12}>
          <FormControl variant="outlined"
                       required={props.required ? props.required : false}
                       error={selectedTestingScopes !== undefined && selectedTestingScopes !== null && selectedTestingScopes.length <= 0}
                       className={classnames(classes.testingScopes, {
                        'testing-scopes-control': true
                      })}>
            <InputLabel id="testing-scopes-label">Services</InputLabel>
            <div className={classnames(classes.testingScopesInput, {
                          'testing-scopes-control-input': true
                        })}>
            <InputAdornment position="start">
              <CategoryIcon />
            </InputAdornment>
            <Select
              labelId="testing-scopes-label"
              id="testing-scopes"
              multiple
              className={classnames(classes.testingScopesSelect, {
                           [classes.error]: selectedTestingScopes !== undefined && selectedTestingScopes !== null && selectedTestingScopes.length <= 0
                         })}
              value={selectedTestingScopes ?? []}
              onChange={handleChange}
              open={testingScopesSelectionOpen}
              onClose={() => {setTestingScopesSelectionOpen(false);}}
              onOpen={() => {setTestingScopesSelectionOpen(true);}}
              input={<Input id="testings-scopes-chip" />}
              renderValue={(selected) => (
                <div className={classes.chips}>
                  {selected.map((value) => {
                    return (
                      <Fragment key={value.id || value}>
                          <Chip label={value.name || testing_scopes.filter(item => item.id === value)[0].name}
                                className={classes.chip}
                                onDelete={() => handleDelete(`${value.id}`)}
                                variant="outlined"
                                onMouseDown={onMouseDown}/>
                        </Fragment>
                  );
                })}
                </div>
              )}
              MenuProps={MenuProps}
              size="small"
            >
              {testing_scopes !== undefined && testing_scopes !== null &&
                testing_scopes.length > 0 &&
                testing_scopes.map((testingScope, index) => (
                     <MenuItem key={testingScope.id} value={testingScope}
                        disabled={selectedTestingScopes !== undefined && selectedTestingScopes !== null && selectedTestingScopes.filter(item => item !== undefined && item !== null && (item.id === testingScope.id || item === testingScope.id)).length === 1}
                        onClick={() => {setTestingScopesSelectionOpen(false);}}>
                        <span className="dropdown-avatar">{testingScope.name}</span>
                     </MenuItem>
              ))}
            </Select>
            {selectedTestingScopes === undefined || selectedTestingScopes === null || selectedTestingScopes.length <= 0 && <FormHelperText className={classes.error}>Please select a service.</FormHelperText>}
            </div>
          </FormControl>

          {testing_scopes !== undefined && testing_scopes !== null &&
            testing_scopes.length > 0 && selectedTestingScopes !== undefined && selectedTestingScopes !== null && selectedTestingScopes.length > 0 &&
            testing_scopes.length > 0 && selectedTestingScopes.some(ts => ts.name.startsWith('Other')) &&
            <TextField
              id="testing_scopes_notes"
              label="Other Services, please specify"
              autoComplete='off'
              onChange={handleOtherTestingScopesSpecified}
              name="name"
              value={notes || ''}
              variant="outlined"
              style={{width: '100%', marginTop: '10px'}}
              required
              error={notes === ''}
              helperText={notes === '' ? 'Please enter the other services.' : ' '}
              size="small"
            />

          }
        </Grid>
        </Grid>

    </div>
  );
//}
});
export default SelectSiteTestingScopes;
